/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { ID } from '@gh/common-shared-data';
import { AbstractRestService, arrayOf, RestSettings, SlicedDataSource } from '@gh/core-data';
import { Observable } from 'rxjs';
import { PurchaseOrdersDto } from './purchase-orders.dto';
import { PurchaseOrdersMapper } from './purchase-orders.mapper';

@Injectable()
export class SupplierPurchaseOrdersRestService extends AbstractRestService {
  constructor(private settings: RestSettings) {
    super(settings);
  }

  findAll(showRejected: boolean, officeId?: ID): SlicedDataSource<PurchaseOrdersDto> {
    return this.createSlicedDataSourceGet(
      `/purchase-orders`,
      {
        officeId,
        showRejected,
      },
      void 0,
      arrayOf(PurchaseOrdersMapper),
    );
  }

  acceptOrder(orderId: ID, version: number): Observable<PurchaseOrdersDto> {
    return this.httpGet(
      `/purchase-orders/${orderId}/accept?version=${version}`,
      PurchaseOrdersMapper,
    );
  }

  rejectOrder(orderId: ID, version: number): Observable<PurchaseOrdersDto> {
    return this.httpGet(
      `/purchase-orders/${orderId}/reject?version=${version}`,
      PurchaseOrdersMapper,
    );
  }
}
